/**
 * Query key factory for Tables
 * 
 * This file provides a consistent way to define query keys for React Query
 * to properly deduplicate and invalidate related queries.
 */

/**
 * Centralized query keys for table-related data to ensure consistent cache management
 */
export const tableKeys = {
  // Base key for all table-related queries
  all: ['tables'] as const,
  
  // Keys for table definitions
  definitions: () => [...tableKeys.all, 'definitions'] as const,
  definitionsByTopic: (topicId: string) => [...tableKeys.definitions(), { topicId }] as const,
  definitionDetail: (id: string) => [...tableKeys.definitions(), id] as const,
  
  // Keys for table columns
  columns: () => [...tableKeys.all, 'columns'] as const,
  columnsByTableDef: (tableDefId: string) => [...tableKeys.columns(), { tableDefId }] as const,
  columnDetail: (id: string) => [...tableKeys.columns(), id] as const,
  
  // Keys for table rows
  rows: () => [...tableKeys.all, 'rows'] as const,
  rowsByTableDef: (tableDefId: string) => [...tableKeys.rows(), { tableDefId }] as const,
  rowDetail: (id: string) => [...tableKeys.rows(), id] as const,
  
  // Keys for table cells
  cells: () => [...tableKeys.all, 'cells'] as const,
  cellsByTableDef: (tableDefId: string) => [...tableKeys.cells(), { tableDefId }] as const,
  cellsByRow: (rowId: string) => [...tableKeys.cells(), { rowId }] as const,
  cellDetail: (id: string) => [...tableKeys.cells(), id] as const,
  
  // Combined table data (all parts together)
  tableData: () => [...tableKeys.all, 'tableData'] as const,
  tableDataByTopic: (topicId: string) => [...tableKeys.tableData(), { topicId }] as const,
};